import React from 'react';
import { CheckIcon } from 'lucide-react';
interface CheckoutStepsProps {
  currentStep: number;
}
export const CheckoutSteps: React.FC<CheckoutStepsProps> = ({
  currentStep
}) => {
  const steps = [{
    id: 1,
    name: 'Shipping'
  }, {
    id: 2,
    name: 'Payment'
  }, {
    id: 3,
    name: 'Review'
  }, {
    id: 4,
    name: 'Confirmation'
  }];
  return <nav aria-label="Progress" data-id="element-58">
      <ol className="flex items-center justify-center" data-id="element-59">
        {steps.map((step, stepIdx) => <li key={step.name} className={`relative ${stepIdx !== steps.length - 1 ? 'pr-8 sm:pr-20' : ''}`} data-id="element-60">
            {step.id < currentStep ? <div className="absolute inset-0 flex items-center" aria-hidden="true" data-id="element-61">
                <div className="h-0.5 w-full bg-fuchsia-600" data-id="element-62" />
              </div> : stepIdx !== 0 ? <div className="absolute inset-0 flex items-center" aria-hidden="true" data-id="element-63">
                <div className="h-0.5 w-full bg-gray-200" data-id="element-64" />
              </div> : null}
            <div className={`relative flex h-8 w-8 items-center justify-center rounded-full ${step.id < currentStep ? 'bg-fuchsia-600' : step.id === currentStep ? 'border-2 border-fuchsia-600 bg-white' : 'border-2 border-gray-300 bg-white'}`} data-id="element-65">
              {step.id < currentStep ? <CheckIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-66" /> : <span className={`text-sm font-medium ${step.id === currentStep ? 'text-fuchsia-600' : 'text-gray-500'}`} data-id="element-67">
                  {step.id}
                </span>}
            </div>
            <div className="mt-2 text-xs font-medium text-center" data-id="element-68">
              {step.name}
            </div>
          </li>)}
      </ol>
    </nav>;
};